import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import EvaluationValueServices from "./EvaluationValue.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

//valores del empleado
export const resetEmployeeValue = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_VALUE,
      payload: true,
    });
    dispatch({
      type: actions.GET_EMPLOYEE_VALUE,
      payload: {
        employeeValues: [],
        employeeValuesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.EMPLOYEE_VALUE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_VALUE,
      payload: false,
    });
  }
};

export const getEmployeeValue = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_EMPLOYEE_VALUE,
      payload: true,
    });
    const resp = await EvaluationValueServices.getEmployeeValue(filters);
    dispatch({
      type: actions.GET_EMPLOYEE_VALUE,
      payload: {
        employeeValues: resp.data || [],
        employeeValuesLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.EMPLOYEE_VALUE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.EMPLOYEE_VALUE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_VALUE,
      payload: false,
    });
  }
};

export const getEmployeeValueById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_VALUE_BY_ID,
      payload: true,
    });
    const resp = await EvaluationValueServices.getEmployeeValueById(id);
    dispatch({
      type: actions.GET_EMPLOYEE_VALUE_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.EMPLOYEE_VALUE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EMPLOYEE_VALUE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_VALUE_BY_ID,
      payload: false,
    });
  }
};

export const saveEmployeeValue = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_VALUE,
      payload: true,
    });
    const resp = await EvaluationValueServices.saveEmployeeValue(data);
    const { employeeValues, employeeValuesLength } = getState().evaluationValue;
    const _employeeValues = employeeValues
    _employeeValues.data = [...employeeValues.data, resp.data];
    dispatch({
      type: actions.GET_EMPLOYEE_VALUE,
      payload: {
        employeeValues: _employeeValues,
        employeeValuesLength: employeeValuesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_VALUE,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_VALUE,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_VALUE,
      payload: false,
    });
  }
};

export const editEmployeeValue = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_VALUE,
      payload: true,
    });
    await EvaluationValueServices.editEmployeeValue(id, data);
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_VALUE,
      payload: "",
    });
    
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_VALUE,
      payload: message,
    });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_VALUE,
      payload: false,
    });
  }
};

export const editEmployeeComment = (data, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_VALUE,
      payload: true,
    });
    await EvaluationValueServices.editEmployeeValue(id, data);
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_VALUE,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_VALUE,
      payload: message,
    });
    toastr.error(message, "", {    
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_VALUE,
      payload: false,
    });
  }
};

export const deleteEmployeeValue = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_VALUE,
      payload: true,
    });
    await EvaluationValueServices.deleteEmployeeValue(id);
    const { employeeValues, employeeValuesLength } = getState().evaluationValue;
    employeeValues.data.splice(index, 1);
    dispatch({
      type: actions.GET_EMPLOYEE_VALUE,
      payload: {
        employeeValues: employeeValues,
        employeeValuesLength: employeeValuesLength - 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_VALUE,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_VALUE,
      payload: false,
    });
  }
};

//valores del jefe

export const resetBossValue = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_BOSS_VALUE,
      payload: true,
    });
    dispatch({
      type: actions.GET_BOSS_VALUE,
      payload: {
        bossValues: [],
        bossValuesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.BOSS_VALUE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_BOSS_VALUE,
      payload: false,
    });
  }
};

export const getBossValue = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_BOSS_VALUE,
      payload: true,
    });
    const resp = await EvaluationValueServices.getBossValue(filters);
    dispatch({
      type: actions.GET_BOSS_VALUE,
      payload: {
        bossValues: resp.data || [],
        bossValuesLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.BOSS_VALUE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.BOSS_VALUE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_BOSS_VALUE,
      payload: false,
    });
  }
};

export const getBossValueById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_BOSS_VALUE_BY_ID,
      payload: true,
    });
    const resp = await EvaluationValueServices.getBossValueById(id);
    dispatch({
      type: actions.GET_BOSS_VALUE_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.BOSS_VALUE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.BOSS_VALUE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_BOSS_VALUE_BY_ID,
      payload: false,
    });
  }
};

export const saveBossValue = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_VALUE,
      payload: true,
    });
    const resp = await EvaluationValueServices.saveBossValue(data);
    const { bossValues, bossValuesLength } = getState().evaluationValue;
    const _bossValues = bossValues
    _bossValues.data = [...bossValues.data, resp.data];
    dispatch({
      type: actions.GET_BOSS_VALUE,
      payload: {
        bossValues: _bossValues,
        bossValuesLength: bossValuesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_BOSS_VALUE,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_BOSS_VALUE,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_VALUE,
      payload: false,
    });
  }
};

export const editBossValue = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_VALUE,
      payload: true,
    });
    await EvaluationValueServices.editBossValue(id, data);
    dispatch({
      type: actions.FORM_FAIL_BOSS_VALUE,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_BOSS_VALUE,
      payload: message,
    });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_VALUE,
      payload: false,
    });
  }
};

export const editBossComment = (data, id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_VALUE,
      payload: true,
    });
    await EvaluationValueServices.editBossValue(id, data);
 
    dispatch({
      type: actions.FORM_FAIL_BOSS_VALUE,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_BOSS_VALUE,
      payload: message,
    });
    toastr.error(message, "", {    
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_VALUE,
      payload: false,
    });
  }
};

export const deleteBossValue = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_BOSS_VALUE,
      payload: true,
    });
    await EvaluationValueServices.deleteBossValue(id);
    const { bossValues, bossValuesLength } = getState().evaluationValue;
    bossValues.data.splice(index, 1);
    dispatch({
      type: actions.GET_BOSS_VALUE,
      payload: {
        bossValues: bossValues,
        bossValuesLength: bossValuesLength - 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_BOSS_VALUE,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_BOSS_VALUE,
      payload: false,
    });
  }
};
